import Vue from 'vue'
import Router from 'vue-router'
import Axios from 'axios'
import 'vant/lib/index.css';
import apiMethod from '../api/index'
import store from '../main.js'
Vue.use(Router)
import Toast from 'vant/lib/toast';
import 'vant/lib/toast/style';


const router = new Router({
  mode: "hash", //history
  base: '/dist/', // __dirname
  routes: [{
    path: "/",
    component: resolve => require(["../App.vue"], resolve),
    children: [{
      //----------------------------------------------------首页-------------------------------------------------------------
      path: "/",
      component: resolve => require(["../home/index.vue"], resolve),
      meta: {
        requireAuth: false,
        keepAlive: false,
        writeoffAuth: true
      }
    },
    {
      //详情
      path: "/home/details",
      component: resolve => require(["../home/details.vue"], resolve),
      meta: {
        requireAuth: false,
        keepAlive: false,
        writeoffAuth: true
      }
    },
    {
      name: 'signin',
      path: "/writeoff/signin",
      component: resolve => require(["../writeoff/signin.vue"], resolve),
      meta: {
        requireAuth: false,
        keepAlive: false
      }
    }
    ],
    meta: {
      requireAuth: false
    }
  }
  ],
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})


// Djyz999888DJYZ   yiqunchougongyi

function getUrlParam(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

router.beforeEach((to, from, next) => {
  if (to.matched.some(res => res.meta.requireAuth)) {
    next()
  } else {
    if (to.matched.some(res => res.meta.writeoffAuth)) {
      if (sessionStorage.getItem('token')) { // 判断是否登录
        next()
      } else { // 没登录则跳转到登录界面
        next({
          path: '/writeoff/signIn'
        })
      }
    } else {
      if (sessionStorage.getItem('token') && to.name === 'signin') {
        next({
          path: '/'
        })
      } else {
        next()
      }
    }
  }
})
router.afterEach((to, from) => {
  let token = sessionStorage.getItem('token')
  if (token) { // 判断是否登录
    let ua = navigator.userAgent.toLowerCase();
    let isWeixin = ua.indexOf('micromessenger') != -1;
    if (isWeixin) {//微信环境
      const AppId = 'wx5e72685318853998';
      const code = getUrlParam('code')
      const local = window.location.href.replace('#', '%23');
      let mandate = store.state.userInfo.mandate
      if (!mandate || !mandate.openid) {
        if (code == null || code == "") {
          window.location.href = 'http://tlhk.xinquanyu.top/empower_tlhk.html?url=' + local;
        } else {
          let formData = new FormData();
          formData.append("platform", 'wechat');
          formData.append("code", code);
          formData.append("token", token);
          apiMethod.post("user/third", formData, (res) => {
            store.state.userInfo.mandate = res.data.mandate
          }, (err) => {
            if (err.msg != "操作失败") {
              Toast(err.msg)
            }
            setTimeout(function () {
              window.sessionStorage.removeItem('token');
              window.location.reload();
            },500)
            console.log(err)
          })
        }
      }
    }
  }
})
new Vue({
  router,
  template: `
		<router-view></router-view>
		`
}).$mount("#app")



// WEBPACK FOOTER //
// ./src/router/index.js